const popOverTypes = {
	MENU: 'menu',
	DIALOG: 'dialog',
	LISTBOX: 'listbox',
	TREE: 'tree',
	GRID: 'grid',
}

export default popOverTypes;